/*
 *  Product Template Quantity Selector
 *    Contains scripts for the Product Template Qty Selector
 *
 *  Version
 *    1.0.0 - 2020/07/15
 */

import $ from 'jquery';

import { QuantitySelector } from './QuantitySelector';
import { ON_VARIANT_CHANGE } from './../variant/VariantSelector';
import { getCountOfVariantInCart } from './../../process/pc-slate-tools';

export class ProductTemplateQuantitySelector extends QuantitySelector {
  constructor(productTemplate, container) {
    super(container);
    this.template = productTemplate;

    $(document).on(ON_VARIANT_CHANGE, (e, variant) => this.useVariant(variant));
    this.useVariant(this.getVariantData());
  }

  getVariantData() {
    let vs = (this.template.swatches || this.template.variantSelector);
    return vs.getVariantData();
  }

  useVariant(variant) {
    let { inventory_policy, inventory_quantity, inventory_management, id } = variant;

    // TODO: FIX EDGE CASE - If a product is in stock but also available for preorder

    // Adjust quantiy selector
    let max = null;
    if(inventory_policy == 'continue' && inventory_quantity <= 0) {
      max = 1;
    } else {
      max = inventory_quantity - getCountOfVariantInCart(id);
    }
    this.setMax(max);

    // Update quantity select options based on max
    let optionsHtml = '';
    if(max < 1) {
      let optionValue = 0;

      if(inventory_policy == 'continue') optionValue = 1;

      optionsHtml = `<option value="${optionValue}">${optionValue}</option>`;
    }
    for(let i = 1; i <= max; i++) {
      optionsHtml += `<option value="${i}">${i}</option>`;
    }
    this.input.find('option').remove();
    this.input.append(optionsHtml);
  }

  onCartFinished() {
    this.useVariant(this.getVariantData());
    super.onCartFinished();
  }

  onQuantityChanged(value, current) {

  }
}
